<template>
	<div>
		<template v-if="headerShow">
			<div class="sqzxOne">
				<div class="sqzxOneFor" v-for="(item,index) in itema.child" :key="index" @click="goClickOne(index)">
					<div class="sqzxOneForImg">
						<img :src="item.icon" />
					</div>
					<div class="sqzxOneForName">
						{{item.title}}
					</div>
					<div class="sqzxOneForCen">
						{{item.desc}}
					</div>
				</div>
				<div class="sqzxOneForXian">
					<div></div>
				</div>
			</div>
			<div class="gjfw">
				<div class="gjfwTil">{{$t('i18n_62')}}</div>
				<div class="gjfwXl" @click="gnShow=!gnShow">
					<div class="gjfwXlName" v-if="gnList.length>0">
						{{gnList[gnSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gnShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gnShow">
						<div class="gjfwXlDwFor" :class="gnSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gnList"
							:key="index" @click.stop="goGnfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gnDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gnDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_63')}}：{{gnDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_64')}}：{{gnDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gnDetail.cover" v-if="gnDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />

					</div>
				</div>
			</div>
			<div class="gjfw" style="margin: 0 auto;">
				<div class="gjfwTil">{{$t('i18n_65')}}</div>
				<div class="gjfwXl" @click="gjShow=!gjShow">
					<div class="gjfwXlName" v-if="gjList.length>0">
						{{gjList[gjSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gjShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gjShow">
						<div class="gjfwXlDwFor" :class="gjSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gjList"
							:key="index" @click.stop="goGjfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian" v-if="gjDetail">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gjDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gjDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_66')}}：{{gjDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_67')}}：{{gjDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gjDetail.cover" v-if="gjDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="sqzxOne">
				<div class="sqzxOneFor" :class="index !== itema.child.length -1?'sqzxOneForBottom':''" v-for="(item,index) in itema.child" :key="index" @click="goClickOne(index)">
					<div class="sqzxOneForImg">
						<img :src="item.icon" />
					</div>
					<div class="sqzxOneForName">
						{{item.title}}
					</div>
					<div class="sqzxOneForCen">
						{{item.desc}}
					</div>
				</div>
				<div class="sqzxOneForXian">
					<div></div>
				</div>
			</div>
			<div class="gjfw">
				<div class="gjfwTil">{{$t('i18n_62')}}</div>
				<div class="gjfwXl" @click="gnShow=!gnShow">
					<div class="gjfwXlName" v-if="gnList.length>0">
						{{gnList[gnSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gnShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gnShow">
						<div class="gjfwXlDwFor" :class="gnSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gnList"
							:key="index" @click.stop="goGnfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gnDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gnDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_63')}}：{{gnDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_64')}}：{{gnDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gnDetail.cover" v-if="gnDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />

					</div>
				</div>
			</div>
			<div class="gjfw" style="margin: 0 auto;">
				<div class="gjfwTil">{{$t('i18n_65')}}</div>
				<div class="gjfwXl" @click="gjShow=!gjShow">
					<div class="gjfwXlName" v-if="gjList.length>0">
						{{gjList[gjSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gjShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gjShow">
						<div class="gjfwXlDwFor" :class="gjSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gjList"
							:key="index" @click.stop="goGjfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian" v-if="gjDetail">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gjDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gjDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_66')}}：{{gjDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_67')}}：{{gjDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gjDetail.cover" v-if="gjDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />
					</div>
				</div>
			</div>

		</template>


	</div>
</template>

<script>
	import {
		get_int_select,
		get_int_service_network,
		get_abroad_select,
		get_abroad_service_network,
	} from '@/api/contact.js'
	export default {
		components: {

		},
		props: {
			itema: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				sqzxOne: [{
						img: require("@/assets/contact/sqzx/gnxs.png"),
						name: this.$t('i18n_68'),
						cen: 'sales@aohua.com'
					},
					{
						img: require("@/assets/contact/sqzx/gjxs.png"),
						name: this.$t('i18n_69'),
						cen: 'oversea@aohua.com'
					},
				],
				gnList: [
					// {
					// 	name:'总部'
					// },
					// {
					// 	name:'安徽省'
					// },
					// {
					// 	name:'北京市'
					// },
					// {
					// 	name:'上海市'
					// },
					// {
					// 	name:'四川省'
					// },
				],
				gnSel: 0,
				gnShow: false,
				gjList: [
					// {
					// 	name:'总部'
					// },
					// {
					// 	name:'安徽省'
					// },
					// {
					// 	name:'北京市'
					// },
					// {
					// 	name:'上海市'
					// },
					// {
					// 	name:'四川省'
					// },
				],
				gjSel: 0,
				gjShow: false,
				gnDetail: {},
				gjDetail: {}
			}
		},
		mounted() {
			// 获取国内下拉
			this.getSelList()
			// 获取国外下拉
			this.getGwSelList()
		},
		methods: {
			goClickOne(e) {
				console.log(e)
			},
			goGnfw(e) {
				this.gnShow = false;
				this.gnSel = e;
				this.getGnDetail();
			},
			goGjfw(e) {
				this.gjSel = e
				this.gjShow = false;
				this.getGjDetail();
			},
			getSelList() {
				let data = {}
				get_int_select(data).then(res => {
					console.log(res)
					this.gnList = res.data.list;
					this.getGnDetail();
				}).catch(err => {
					console.log(err)
				})
			},
			getGnDetail() {
				let data = {
					province_id: this.gnList[this.gnSel].value
				}
				get_int_service_network(data).then(res => {
					console.log(res)
					this.gnDetail = res.data.list.length > 0 ? res.data.list[0] : {};
				}).catch(err => {
					console.log(err)
				})
			},
			getGwSelList() {
				let data = {}
				get_abroad_select(data).then(res => {
					console.log(res)
					this.gjList = res.data.list;
					this.getGjDetail();
				}).catch(err => {
					console.log(err)
				})

			},
			getGjDetail() {
				let data = {
					country: this.gjList[this.gjSel].value
				}
				get_abroad_service_network(data).then(res => {
					console.log(res)
					this.gjDetail = res.data.list.length > 0 ? res.data.list[0] : {}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.sqzxOne {
		width: 1200px;
		margin: 0 auto;
		background: #fafafa;
		display: flex;
		justify-content: center;
		height: 400px;
		// .sqzxOneFor:first-child{
		// 	border-right: 2px solid #AFAFAF;
		// }
		position: relative;

		.sqzxOneForXian {

			position: absolute;
			top: 0;
			right: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: center;

			>div {
				width: 2px;
				height: 200px;
				background: #AFAFAF;

			}
		}

		.sqzxOneFor {
			width: 600px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			position: relative;
			z-index: 2;

			.sqzxOneForImg {
				img {
					width: 120px;
					height: 120px;
				}
			}

			.sqzxOneForName {
				font-size: 35px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-top: 30px;
			}

			.sqzxOneForCen {
				margin-top: 16px;
				font-size: 23px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
			}
		}
	}

	.gjfw {
		width: 1200px;
		margin: 0 auto;
		margin-top: 117px;
		padding-bottom: 95px;

		.gjfwTil {
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 96px;
		}

		.gjfwXl {
			width: 400px;
			padding-bottom: 18px;
			margin-bottom: 43px;
			border-bottom: 2px solid #ADADAD;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;

			.gjfwXlName {
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
			}

			.gjfwXlJt {
				img {
					width: 35px;
					height: 20px;
				}
			}

			.gjfwXlDw {
				position: absolute;
				bottom: -200px;
				left: 0;
				width: 100%;
				height: 182px;
				background: #FFFFFF;
				box-shadow: 0px 1px 6px 0px rgba(39, 39, 39, 0.2);
				border-radius: 10px;
				overflow-y: auto;
				padding: 10px 30px;
				box-sizing: border-box;

				.gjfwXlDwFor {
					// font-size: 24px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
					height: 40px;
					display: flex;
					align-items: center;
					cursor: pointer;
				}

				.gjfwXlDwForXz {
					color: #1A2588;
				}
			}
		}

		.gjfwDdian {
			display: flex;
			align-items: center;
			width: 1200px;
			height: 400px;
			background: #fafafa;
			padding: 48px 128px;
			box-sizing: border-box;

			.gjfwDdianLeft {
				flex: 1;
				width: 0;
				height: 100%;
				display: flex;
				flex-direction: column;

				.gjfwDdianLeftOne {
					// font-size: 36px;
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #6A6A6A;
					flex: 1;
				}

				.gjfwDdianLeftTwo {
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #000000;
					margin-bottom: 35px;
				}

				.gjfwDdianLeftThree {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #4C4C4C;
					margin-bottom: 23px;
				}

				.gjfwDdianLeftFour {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #4C4C4C;
				}
			}

			.gjfwDdianRight {
				margin-left: 30px;

				img {
					width: 400px;
					height: 305px;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.sqzxOne {
			width: 100% !important;
			height: auto !important;
			// background-color: red;
			display: block !important; 
			.sqzxOneFor{
				width: 100% !important;
				padding-bottom: 10px !important;
			}
			.sqzxOneForBottom{
				border-bottom: 2px solid #eeeeee;
			}

			.sqzxOneForName {
				font-size: 20px !important;
			}

			.sqzxOneForCen {
				font-size: 18px !important;
			}
			.sqzxOneForXian{
				display: none;
			}
		}

		.gjfw {
			width: 100% !important;
			// background-color: green;
			margin-top: 10px !important;
			height: auto !important;
			padding: 0 30px !important;
			box-sizing: border-box !important; 
			.gjfwTil {
				font-size: 28px !important;
				margin-bottom: 10px !important;
			}

			.gjfwXl {
				width: 100% !important;
				margin-bottom: 0 !important;
				.gjfwXlName {
					font-size: 20px !important;
				}

				.gjfwXlJt {
					img {
						width: 20px !important;
						height: 10px !important;
					}
				}
			}
		}

		.gjfwDdian {
			width: 100% !important;
			// background-color: pink !important;
			padding: 0 !important;
			height: auto !important; 
			display: block !important; 
			margin-top: 10px !important;
			.gjfwDdianLeft{
				height: auto !important;
				width: 100% !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				.gjfwDdianLeftOne{
					height: auto !important; 
					font-size: 25px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftTwo{
					font-size: 20px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftThree{
					font-size: 14px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftFour{
					font-size: 14px !important;
				}
			}

			.gjfwDdianRight {
				width: 100%;
				margin: 0 !important;
				margin-top: 10px !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				img {
					width: 100% !important;
					height: auto !important;
				}
			}
		}
	}
</style>